module.exports = __webpack_public_path__ + "static/media/capitaldynamics.2334e353.png";